function PageHeading($window) {
	'ngInject';

	const service = {
		'getPageHeading': getPageHeading,
		'setPageHeading': setPageHeading
	};

	let pageHeading = '';

	return service;

	function getPageHeading() {
		return pageHeading;
	}

	function setPageHeading(heading, title = '') {
		if (title) {
			$window.document.title = title;
		}

		pageHeading = heading;
	}
}

export default PageHeading;



/** WEBPACK FOOTER **
 ** ./client/components/page-heading/page-heading.service.js
 **/